import React from 'react';
import { Star, Quote, MapPin } from 'lucide-react';

const Testimonials = () => {
    // Top 6 genuine Google reviews
    const testimonials = [
        {
            name: 'Dr. S K Chatterji',
            rating: 5,
            text: 'Mr Manjunath is an excellent massage therapy expert. He is punctual for home service and uses good quality material for massage. I have been using his services for a long time and I am very satisfied. Highly recommended.',
            time: 'a year ago',
            badge: 'Verified',
        },
        {
            name: 'Srinivas Narayana',
            rating: 5,
            text: 'Excellent massage at doorsteps. Manjunath is a highly skilled, hygienic and qualified massager for full-body and head. Special Oil ingredients with zen meditation audio background music gives good result in healing pains and blood flow.',
            time: 'a year ago',
            badge: 'Local Guide',
        },
        {
            name: 'Aparna Balasubramanian',
            rating: 5,
            text: 'Very good and therapeutic. Has helped in recovery from severe back pain and we have been continuing the service for regular healthy maintenance of body. That makes a huge difference in the well being overall.',
            time: '7 months ago',
            badge: 'Verified',
        },
        {
            name: 'GURURAJ KULKARNI',
            rating: 5,
            text: 'Mr. Manjunath is very sincere and dedicated at his work. I am taking a massage from him for the last 10 years. He is a very professional therapist. I feel relaxed after his massage. He visits home.',
            time: 'a year ago',
            badge: '10 Year Client',
        },
        {
            name: 'Md Sufiyan',
            rating: 5,
            text: 'I highly recommend Manjunath for his exceptional massage therapy services. His technique demonstrates years of experience and deep knowledge of body mechanics. What sets him apart is his ability to identify problem areas and apply the right amount of pressure.',
            time: '9 months ago',
            badge: 'Verified',
        },
        {
            name: 'somashekar B R',
            rating: 5,
            text: 'I have been taking both Foot and full Body massages from Mr.Manjunath for more than 3 years now. He is very thorough and professional in his work and I am very happy and satisfied. Cost also is reasonable.',
            time: 'a year ago',
            badge: '3 Year Client',
        },
    ];

    return (
        <section className="py-20 bg-gradient-to-b from-white to-cream">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <div className="inline-flex items-center bg-zen-gold/10 px-6 py-2 rounded-full mb-6">
                        <span className="text-coffee-900 font-semibold">⭐ 5.0 Rating on Google</span>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-display font-bold text-coffee-900 mb-4">
                        Client Reviews
                    </h2>
                    <p className="text-lg text-coffee-700 max-w-2xl mx-auto">
                        Real reviews from Google. Trusted by thousands in Bengaluru.
                    </p>
                </div>

                {/* Testimonials Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={index}
                            className="premium-card bg-white p-8 rounded-2xl shadow-premium relative"
                        >
                            {/* Quote Icon */}
                            <div className="absolute top-6 right-6 text-zen-gold/20">
                                <Quote size={40} />
                            </div>

                            {/* Badge */}
                            <div className="inline-flex items-center bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold mb-4">
                                ✓ {testimonial.badge}
                            </div>

                            {/* Rating Stars */}
                            <div className="flex gap-1 mb-4">
                                {[...Array(testimonial.rating)].map((_, i) => (
                                    <Star
                                        key={i}
                                        size={18}
                                        className="fill-yellow-400 text-yellow-400"
                                    />
                                ))}
                            </div>

                            {/* Review Text */}
                            <p className="text-coffee-700 mb-6 leading-relaxed text-sm">
                                "{testimonial.text}"
                            </p>

                            {/* Client Info */}
                            <div className="border-t border-coffee-900/10 pt-4 flex items-center justify-between">
                                <div>
                                    <h4 className="font-bold text-coffee-900">
                                        {testimonial.name}
                                    </h4>
                                    <p className="text-xs text-coffee-500">
                                        {testimonial.time}
                                    </p>
                                </div>
                                {/* Google Icon */}
                                <svg className="w-6 h-6" viewBox="0 0 48 48">
                                    <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
                                    <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
                                    <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z" />
                                    <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
                                </svg>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA */}
                <div className="text-center mt-12">
                    {/* View More Reviews Button */}
                    <a
                        href="https://share.google/J4IgzufcF6w8UtnCg"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-white border-2 border-zen-gold text-coffee-900 px-8 py-4 rounded-full font-semibold text-lg hover:bg-zen-gold hover:text-white transition-all duration-300 shadow-premium mb-6"
                    >
                        <svg className="w-6 h-6" viewBox="0 0 48 48">
                            <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
                            <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
                            <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z" />
                            <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
                        </svg>
                        View All Google Reviews
                    </a>

                    <p className="text-coffee-700 mb-6">
                        Join thousands of satisfied clients
                    </p>
                    <a
                        href="tel:+919901853969"
                        className="inline-block bg-zen-gold text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-coffee-900 transition-all duration-300 shadow-premium hover:shadow-glow"
                    >
                        Book Your Session Now
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
